import { Toast } from 'primereact/toast';
import React from 'react';
import ReactDOM from 'react-dom/client';

const toast = { current: null };
const container = document.createElement("div");
container.id = "app-toast-container";
document.body.append(container);
const root = ReactDOM.createRoot(container);
root.render(React.createElement(Toast, { ref: toast }));

export { toast as default };
//# sourceMappingURL=toast.js.map
